export default "__VITE_PUBLIC_ASSET__ee3dfa74__"